var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-hover-primary px-1",attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.toggle}},[_c('i',{staticClass:"align-middle cursor-pointer",class:[_vm.options.icon, _vm.isActive && 'text-primary']})])
}
var staticRenderFns = []

export { render, staticRenderFns }